import React from "react";
import { CorpLocationRefdataContext } from "./corpLocations";
import { EeCodeRefdataContext } from "./eeCodes";
import { DivisionRefdataContext } from "./divisions";
import { FieldOfficeRefdataContext } from "./fieldOffices";
import { ProjectTypeRefdataContext } from "./projectTypes";
import { ServiceDescriptionRefdataContext } from "./serviceDescriptions";
import { StateCountyRefdataContext } from "./stateCounties";
import { WorkLocationRefdataContext } from "./workLocations";
import { EogAfeTypeValuesRefDataContext } from "./eogAfeTypeValues";
import { SharedDrivesRefDataContext } from "./sharedDrives";
import { CompanyRoleRefdataContext } from "./companyRoles";

export * from "./stateCounties";
export * from "./fieldOffices";

export const RefDataProvider: React.FC = ({ children }) => (
  <StateCountyRefdataContext>
    <FieldOfficeRefdataContext>
      <ProjectTypeRefdataContext>
        <CorpLocationRefdataContext>
          <DivisionRefdataContext>
            <ServiceDescriptionRefdataContext>
              <WorkLocationRefdataContext>
                <SharedDrivesRefDataContext>
                  <EogAfeTypeValuesRefDataContext>
                    <CompanyRoleRefdataContext>
                      <EeCodeRefdataContext>{children}</EeCodeRefdataContext>
                    </CompanyRoleRefdataContext>
                  </EogAfeTypeValuesRefDataContext>
                </SharedDrivesRefDataContext>
              </WorkLocationRefdataContext>
            </ServiceDescriptionRefdataContext>
          </DivisionRefdataContext>
        </CorpLocationRefdataContext>
      </ProjectTypeRefdataContext>
    </FieldOfficeRefdataContext>
  </StateCountyRefdataContext>
);
